module.exports = __webpack_public_path__ + "img/zhaoshang_chuangye@2x.c35bcfa2.png";